import axios from "axios";
import { toast } from "react-toastify";
import { retrieveToken } from "../utils/cryptoStorage";

const LOCATION_API_URL = import.meta.env.VITE_API_URL_SERVICE;

// Axios instance configuration
const locationAxiosInstance = axios.create({
  baseURL: LOCATION_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add Authorization token dynamically
locationAxiosInstance.interceptors.request.use(
  async (config) => {
    const token = retrieveToken("accessToken"); // Fetch token dynamically for each request
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Optionally, you can handle the absence of the token more gracefully
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 403 errors and network errors globally
locationAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 ||
      error.response?.status === 401
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Centralized error handling (excluding 403 and network errors)
const handleError = (error) => {
  if (error.isAxiosError && error.response) {
    const { statusCode, message } = error.response.data;

    if (message) {
      toast.error(message);
    }
    switch (statusCode) {
      case 500:
        throw new Error(
          "Server Error (500): The server encountered an issue. Please try again later."
        );
      case 422:
        throw new Error(
          "Validation Error (422): Invalid or incomplete data provided."
        );
      case 401:
        localStorage.clear();
        window.location.href = "/login";
        throw new Error(
          "Unauthorized (401): Access is denied. Please check your login status."
        );
      default:
        throw new Error(`API Error: Received unexpected status code ${status}`);
    }
  } else {
    throw new Error(error.message || "An unexpected error occurred.");
  }
};

// API method to fetch wards
export const fetchReports = async (params) => {
  try {
    const response = await locationAxiosInstance.get(`/reports-admin/v1`, {
      params,
    });
    return response?.data.data;
  } catch (error) {
    // handleError(error);
  }
};
